import { get } from '@core/api/client';
import { endpoints } from '@core/api/endpoints';

export type ScheduledMeetingStatus = 'booked' | 'cancelled' | 'pending_review';

export interface ScheduledMeeting {
  id: string;
  tenantId: string;
  agentId: string;
  sessionId: string;
  googleEventId: string | null;
  calendarId: string;
  title: string;
  startsAt: string;
  endsAt: string;
  timezone: string;
  attendeeEmail: string | null;
  attendeeName: string | null;
  meetUrl: string | null;
  status: ScheduledMeetingStatus;
  createdAt: string;
  updatedAt: string;
}

export interface ListScheduledMeetingsQuery {
  agentId?: string;
  status?: ScheduledMeetingStatus;
}

export const scheduledMeetingService = {
  list(params?: ListScheduledMeetingsQuery): Promise<ScheduledMeeting[]> {
    return get<ScheduledMeeting[]>(endpoints.meetings.list, { params });
  },

  getById(id: string): Promise<ScheduledMeeting> {
    return get<ScheduledMeeting>(endpoints.meetings.getById(id));
  },
};
